export const resolveProduct = (product: string): string =>
	product === 'jsm' ||
	(product === 'jira' &&
		typeof window !== 'undefined' &&
		/^\/jira\/(?:servicedesk|ops)(?:\/|$)/.test(window.location.pathname))
		? 'jira-service-management'
		: product;
